module.exports = "query IssuesCustomizeIssueTitleQuery{issueTitlePredefinedMessages{edges{node{id rowId title message sortOrder}}}}"